import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";
function PreSoloThree({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [airportOne, setAirportOne] = React.useState("")
  const [airportTwo, setAirportTwo] = React.useState("")
  const dispatch = useDispatch()

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received flight training at night on night flying procedures that include takeoffs, approaches, landings, and go-arounds at night at the ${airportOne} airport where the solo flight will be conducted; navigation training at night in the vicinity of the ${airportTwo} airport where the solo flight will be conducted. This endorsement expires 90 calendar-days from the date the flight training at night was received.`
    dispatch(setTemplateText(templateText))
  }, [name, airportOne, airportTwo, dispatch])

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 1552.23(c)/(d)</label>
      </div>

      <div className="col-12 my-2">
        <p className="certificate_text">
          I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received flight training at night on night flying procedures that include takeoffs, approaches, landings, and go-arounds at night at the <input type="text" onChange={(e) => setAirportOne(e.target.value)} placeholder="airport" /> where the solo flight will be conducted; navigation training at night in the vicinity of the <input type="text" onChange={(e) => setAirportTwo(e.target.value)} placeholder="airport" /> where the solo flight will be conducted. This endorsement expires 90 calendar-days from the date the flight training at night was received.
        </p>
      </div>
    </TemplateLayout>
  );
}

export default PreSoloThree;
